import { NotificationOld } from 'types/common/notification';

export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';

export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';

export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

export const RESET_REDUCER = 'RESET_NOTIFICATION_REDUCER';

type NotificationCreate = Omit<NotificationOld, 'id'> & { id?: NotificationOld['id'] };

export type NotificationCreateAction = {
  type: 'CREATE_NOTIFICATION';
  notification: NotificationCreate;
};

export type NotificationDeleteAction = {
  type: 'DELETE_NOTIFICATION';
  id: string;
};

export type NotificationClearAction = {
  type: 'CLEAR_NOTIFICATIONS';
};

export type NotificationResetAction = { type: 'RESET_NOTIFICATION_REDUCER' };

export type NotificationActions = NotificationCreateAction | NotificationDeleteAction | NotificationClearAction | NotificationResetAction;

export type NotificationReducerState = { notifications: NotificationOld[] };
